import { Z_STACK } from '../config/layout'
import { useExperienceStore } from '../store/experienceStore'

const STEPS = [
  {
    title: '你就是 Lucy',
    body: '坐在画面中下方的就是你。周围是可以穿越的时空场域。',
  },
  {
    title: '用手势控制时间',
    body: '掌心偏左 → 倒流过去；偏右 → 奔向未来。张开加速，握拳暂停。双手抬起也可强制暂停。',
  },
  {
    title: '键鼠随时可用',
    body: '拖动底部时间轴精确定位；滚轮调节流速；空格暂停 / 恢复；← → 方向加速。',
  },
]

export function Onboarding() {
  const step = useExperienceStore((s) => s.onboardingStep)
  if (step === null || step < 0 || step >= STEPS.length) return null

  const s = STEPS[step]
  const isLast = step === STEPS.length - 1

  return (
    <div className="onboarding" style={{ zIndex: Z_STACK.modal }}>
      <div className="onboarding-card">
        <div className="onboarding-progress">
          {STEPS.map((_, i) => (
            <span key={i} className={i <= step ? 'dot active' : 'dot'} />
          ))}
        </div>
        <h2>{s.title}</h2>
        <p>{s.body}</p>
        <div className="modal-actions">
          <button
            type="button"
            className="btn-ghost"
            onClick={() => useExperienceStore.getState().setOnboardingStep(null)}
          >
            跳过
          </button>
          <button
            type="button"
            className="btn-primary"
            onClick={() =>
              useExperienceStore
                .getState()
                .setOnboardingStep(isLast ? null : step + 1)
            }
          >
            {isLast ? '开始穿越' : '下一步'}
          </button>
        </div>
      </div>
    </div>
  )
}
